

























import Vue from 'vue'
import {mapGetters, mapState} from 'vuex'
import AlertEliminazioneRilevamento from './AlertEliminazioneRilevamento.vue'
import CercaIndirizzo from './CercaIndirizzo.vue'
import MapplantsInfoRilevamento from '@/components/mapplants/modals/MapplantsInfoRilevamento.vue'
import InterventiEseguiti from '@/components/mapplants/modals/InterventiEseguiti.vue'
import Login from './Login.vue'
import NotificationAlert from './NotificationAlert.vue'
import ReportAggiungiSegnalazione from '@/components/report/modals/ReportAggiungiSegnalazione.vue'
import ReportInfoRilevamento from '@/components/report/modals/ReportInfoRilevamento.vue'
import ReportNoteModificaSegnalazione from '@/components/report/modals/ReportNoteModificaSegnalazione.vue'
import SplashScreenMain from './splashscreens/SplashScreenMain.vue'
import SplashScreenMapPlants from './splashscreens/SplashScreenMapPlants.vue'
import SplashScreenReport from './splashscreens/SplashScreenReport.vue'
// == puntiluce ==
import PuntiLuceModalStatistiche from '@/components/puntiluce/modals/ModalStatistiche.vue'

export default Vue.extend({
    components: {
        AlertEliminazioneRilevamento,
        CercaIndirizzo,
        InterventiEseguiti,
        Login,
        MapplantsInfoRilevamento,
        NotificationAlert,
        SplashScreenMain,
        SplashScreenMapPlants,
        SplashScreenReport,
        ReportAggiungiSegnalazione,
        ReportInfoRilevamento,
        ReportNoteModificaSegnalazione,
        PuntiLuceModalStatistiche
    },
    computed: {
        ...mapGetters('auth', ['isAuthenticated']),
        ...mapState('modal', ['activeNotification', 'activeModal'])
    }
})
